import script from "./BaseHeader.vue?vue&type=script&setup=true&lang=js"
export * from "./BaseHeader.vue?vue&type=script&setup=true&lang=js"

import "./BaseHeader.vue?vue&type=style&index=0&id=67b311ba&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-67b311ba"]])

export default __exports__